import Decimal from 'decimal.js';

// k/M abbreviation for tight mobile display.
// Per spec: values ≥ 100,000 abbreviate to "100k" / "1.2M".
//   100,000   → "100k"
//   1,200,000 → "1.2M"
//   10,000,000 → "10M"

const THOUSAND = new Decimal(1_000);
const HUNDRED_THOUSAND = new Decimal(100_000);
const MILLION = new Decimal(1_000_000);

export function abbreviateNumber(value: Decimal, locale = 'en-US'): string {
  const abs = value.abs();
  if (abs.gte(MILLION)) {
    const scaled = value.div(MILLION);
    const decimals = scaled.abs().gte(100) ? 0 : 1;
    return formatDecimal(scaled, locale, decimals) + 'M';
  }
  if (abs.gte(HUNDRED_THOUSAND)) {
    const scaled = value.div(THOUSAND).round();
    return formatDecimal(scaled, locale, 0) + 'k';
  }
  return formatDecimal(value, locale, 0);
}

function formatDecimal(value: Decimal, locale: string, decimals: number): string {
  // Intl.NumberFormat is the unavoidable number-domain boundary.
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  }).format(Number(value.toFixed(decimals)));
}

// Re-export the threshold so other modules can use the same cutoff.
export { HUNDRED_THOUSAND as ABBREVIATE_THRESHOLD };
